import React from 'react';
import { Receipt, CheckCircle, AlertCircle } from 'lucide-react';

/**
 * Card de conferência física (lado direito)
 */
export default function CardConferenciaFisica({
  physicalValue,
  onPhysicalValueChange,
  isMatch,
  difference,
  showSuccess,
  onCloseDay
}) {
  return (
    <div className="bg-[#1b5e20] p-10 rounded-[3.5rem] shadow-2xl text-white space-y-8 flex flex-col justify-between relative overflow-hidden group">
      <div className="relative z-10">
        <h2 className="text-2xl font-black flex items-center gap-3 text-green-100 mb-8">
          <Receipt /> Conferência de Gaveta
        </h2>
        
        <div className="bg-black/20 p-10 rounded-[3rem] border-4 border-white/10 shadow-inner group-focus-within:border-white/30 transition-all">
          <label className="block text-[10px] font-black text-green-200/60 uppercase tracking-[0.3em] mb-4 text-center">
            Valor Físico Contado
          </label>
          <input 
            type="number" 
            step="0.01"
            autoFocus
            className="w-full bg-transparent text-7xl font-black text-white text-center outline-none placeholder:text-white/20" 
            value={physicalValue || ''} 
            onChange={e => onPhysicalValueChange(Number(e.target.value) || 0)} 
            placeholder="0.00" 
          />
        </div>
        
        <div className={`mt-8 p-8 rounded-[3rem] flex items-center gap-6 shadow-2xl transition-all border-4 border-white/20 ${
          isMatch ? 'bg-emerald-500' : 'bg-orange-600'
        }`}>
          <div className="bg-white text-slate-900 p-5 rounded-full shadow-lg">
            {isMatch ? (
              <CheckCircle size={40} className="text-emerald-600" />
            ) : (
              <AlertCircle size={40} className="text-orange-600" />
            )}
          </div>
          <div>
            <p className="font-black uppercase text-[10px] opacity-70 tracking-widest">
              {isMatch ? 'Caixa Confirmado' : 'Diferença Detetada'}
            </p>
            <p className="text-4xl font-black tracking-tight">
              {isMatch ? 'CONFERIDO' : `${Number(difference).toFixed(2)}€`}
            </p>
          </div>
        </div>
      </div>
      
      <button 
        onClick={onCloseDay}
        disabled={showSuccess}
        className={`relative z-10 w-full py-8 font-black text-3xl rounded-[2.5rem] shadow-2xl transition-all mt-4 border-b-8 active:scale-95 flex items-center justify-center gap-3 ${
          showSuccess 
            ? 'bg-emerald-400 text-white border-emerald-600' 
            : 'bg-white text-[#1b5e20] border-slate-200 hover:bg-green-50'
        }`}
      >
        {showSuccess ? (
          <>
            <CheckCircle size={32}/> Registado!
          </>
        ) : (
          'Registar e Fechar o Dia'
        )}
      </button>
    </div>
  );
}



